import { render, staticRenderFns } from "./vendors.vue?vue&type=template&id=f35744e4&scoped=true"
import script from "./vendors.vue?vue&type=script&lang=js"
export * from "./vendors.vue?vue&type=script&lang=js"
import style0 from "./vendors.vue?vue&type=style&index=0&id=f35744e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35744e4",
  null
  
)

export default component.exports